module.exports = __webpack_public_path__ + "static/media/LogoAlura.ecc0be87.png";